import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import BrimiLogo from "@/components/BrimiLogo";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post("/auth/google-session", { session_id });
        setUser(res.data.user);
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: res.data.user }, replace: true });
      } catch (e) {
        if (process.env.NODE_ENV === "development") {
          console.error("Google session exchange failed", e);
        }
        navigate("/login?err=google");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B1120] text-white">
      <div className="flex flex-col items-center gap-3">
        <BrimiLogo size={48} withBadge />
        <Loader2 className="w-6 h-6 animate-spin text-yellow-400" />
        <p className="font-display text-lg">Signing you in…</p>
      </div>
    </div>
  );
}
